import PropTypes from 'prop-types';
import React from 'react';

import BackArrow, { DIRECTIONS } from 'components/BackArrow';
import { Drawer, DrawerPanel } from 'components/Drawer';
import { medium } from 'constants/mediaQueries';
import Theme from 'styles/theme';
import I18n from 'utils/I18n';

const DRAWER_WIDTH = 267;
const TABLET_DRAWER_WIDTH = 480;

const CollectionFilterDrawer = ({ isOpen, onClose, children }) => (
  <div className="CollectionFilterDrawer" id="collection-filter-drawer" tabIndex="-1">
    <Drawer visible={isOpen}>
      <div className="CollectionFilterDrawer__header-container">
        <div className="CollectionFilterDrawer__header">
          <BackArrow onClick={onClose} direction={DIRECTIONS.RIGHT}>
            {I18n.localize('collectionPage.filterActions.hide')}
          </BackArrow>
        </div>
      </div>
      <DrawerPanel position="left" visible>
        <div className="CollectionFilterDrawer__content">{children}</div>
      </DrawerPanel>
    </Drawer>
    <style jsx>{`
      .CollectionFilterDrawer__header-container {
        position: absolute;
        top: 0;
        width: 100%;
        background-color: ${Theme.get('colors-white')};
        z-index: ${Theme.get('z-index-drawer-sticky-header')};
      }

      .CollectionFilterDrawer__header {
        padding: ${Theme.get('spacing-px')} ${Theme.get('spacing') * 4}px;
        border-bottom: 1px solid ${Theme.get('colors-black-20')};
      }

      .CollectionFilterDrawer__content {
        padding-top: ${Theme.get('spacing') * 8}px;
      }
    `}</style>
    <style jsx global>{`
      .CollectionFilterDrawer .Drawer > .Drawer__content {
        width: ${DRAWER_WIDTH}px;
      }

      @media ${medium} {
        .CollectionFilterDrawer .Drawer > .Drawer__content {
          width: ${TABLET_DRAWER_WIDTH}px;
        }
      }
    `}</style>
  </div>
);

CollectionFilterDrawer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export default CollectionFilterDrawer;
